type CarouselNavButtonsProps = {
  onPrevClick: () => void
  onNextClick: () => void
  navState: {
    prev: boolean
    next: boolean
  }
}

const CarouselNavButtons = ({
  onNextClick,
  onPrevClick,
  navState,
}: CarouselNavButtonsProps) => {
  return (
    <div className="flex gap-6">
      <button
        className="shelf-v2-controlButton flex items-center justify-center left  w-[48px] h-[48px] rounded-round border border-primary"
        onClick={onPrevClick}
        type="button"
        aria-label="Ver proximas características do produto"
        disabled={!navState.prev}
      >
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.53033 0L7.59099 1.06066L2.12132 6.53033L7.59099 12L6.53033 13.0607L0 6.53033L6.53033 0Z"
            fill={navState.prev ? '  #101010' : '#A4ADB7'}
          />
        </svg>
      </button>
      <button
        className="shelf-v2-controlButton flex items-center justify-center right w-[48px] h-[48px] rounded-round border border-primary"
        onClick={onNextClick}
        type="button"
        aria-label="Ver caracteristicas anteriores do produto"
        disabled={!navState.next}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.53034 18.5303L8.46968 17.4697L13.9393 12L8.46968 6.53033L9.53034 5.46968L16.0607 12L9.53034 18.5303Z"
            fill={navState.next ? '#101010' : '#A4ADB7'}
          />
        </svg>
      </button>
    </div>
  )
}

export default CarouselNavButtons
